import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Grid, TextField, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class AddMediaFolder extends Component {
  state = {
    folder_name: "",
    images: [],
    youtube_id: "",
    description: "",
    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  // 🔹 Handle text inputs
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 Handle description editor
  handleDescription = (content) => {
    this.setState({ description: content });
  };

  // 🔹 Handle multiple image upload
  handleImageUpload = (e) => {
    this.setState({
      images: e.target.files,
    });
  };

  // 🔹 Submit Form
  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.state.folder_name) {
      return this.setState({
        notification: true,
        message: "Folder name is required",
      });
    }

    if (!this.state.images.length) {
      return this.setState({
        notification: true,
        message: "Please select images",
      });
    }

    this.setState({ loading: true });

    try {
      const fd = new FormData();

      // ✅ Append folder name
      fd.append("folder_name", this.state.folder_name);

      // ✅ Append multiple images
      for (let i = 0; i < this.state.images.length; i++) {
        fd.append("images", this.state.images[i]);
      }

      const resp = await axios.post(Constants.postUrls.createMediaFolder, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      this.setState({
        notification: true,
        message: "Uploaded successfully!",
        loading: false,
      });

      setTimeout(() => {
        this.setState({
          redirect: true,
        });
      }, 2000);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/media" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Upload Images Folder
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Folder Name */}
                  <Grid item sm={6}>
                    <TextField
                      label="Folder Name"
                      name="folder_name"
                      value={this.state.folder_name}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Multiple Images */}
                  <Grid item sm={12}>
                    <input
                      type="file"
                      multiple
                      onChange={this.handleImageUpload}
                    />
                  </Grid>
                </Grid>

                {/* Submit Button */}
                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Uploading..." : "Upload"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            {/* Snackbar */}
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Upload Status"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
